<template>
  <router-link class="fixedCar" :to="'/shopcart/cart?shopAlias='+this.$route.query.shopAlias">
    <img src="../images/goods/car.png" alt="购物车">
    <span v-if="index<=99">
      <font v-if="getdatanull(index)">
        {{index}}
      </font>
    </span>
    <span v-else>
      <font>
        99+
      </font>
    </span>
  </router-link>
</template>

<script>
import api from '@/fetch/api'
export default {
  name: 'cart',
  data () {
    return {
      index:[],
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let count = {
        loginShopAlias:this.$route.query.shopAlias
      }
      api.countshopcart(this.geturl(count))
        .then(res=>{
          this.index = res.resultObj;
        })
    }
  },
  props:{
    alias:''
  },
  watch:{
    'alias': function(val) {
            this.init();

          }
      }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// timer.vue?da75ebba



// WEBPACK FOOTER //
// src/components/cart.vue